import { render, staticRenderFns } from "./SellerSendCartToCustomer.vue?vue&type=template&id=3faa362c&scoped=true"
import script from "./SellerSendCartToCustomer.vue?vue&type=script&lang=js"
export * from "./SellerSendCartToCustomer.vue?vue&type=script&lang=js"
import style0 from "./SellerSendCartToCustomer.vue?vue&type=style&index=0&id=3faa362c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa362c",
  null
  
)

export default component.exports